import { ReactNode } from "react";
import "../components-styles.scss";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import AddressForm from "../ClientSpace/Signup/EstablishmentForms/EstablishmentAddress/AddressForm";
import CustomCheckBox from "../UIElements/CustomCheckBox";

type EstablishementAdressFormWrapperProps = {
    defaultValues: any;
    onSubmit: (data: any) => void;
    className?: string;
    formActionComponents: {
        submit: ReactNode;
        cancel?: ReactNode;
    };
    classes?: any;
};

const validationSchema = yup.object().shape({
    contactAddress: yup.object().shape({
        postalCode: yup
            .string()
            .required("Veuillez renseigner le code postal")
            .matches(
                /^\d{5}(?:[-\s]\d{4})?$/,
                "Veuillez renseigner unn code postal valide"
            ),
        city: yup.string().required("Veuillez renseigner la ville").nullable(),
        street: yup.string().required("Veuillez renseigner le code postale"),
        additionalDetails: yup.string(),
    }),
    billingAddress: yup.object().when(["useDiffrentBillingAddress"], {
        is: (useDiffrentBillingAddress: boolean) => useDiffrentBillingAddress,
        then: () =>
            yup.object().shape({
                postalCode: yup
                    .string()
                    .required("Veuillez renseigner le code postal")
                    .matches(
                        /^\d{5}(?:[-\s]\d{4})?$/,
                        "Veuillez renseigner unn code postal valide"
                    ),

                city: yup.string().required("Veuillez renseigner la ville"),
                street: yup
                    .string()
                    .required("Veuillez renseigner une adresse postale"),
                additionalDetails: yup.string(),
            }),
        otherwise: () =>
            yup.object().shape({
                postalCode: yup.string(),
                city: yup.string(),
                street: yup.string(),
                additionalDetails: yup.string(),
            }),
    }),

    useDiffrentBillingAddress: yup.boolean(),
});

export default function EstablishmentAdressFormWrapper({
    defaultValues,
    onSubmit,
    className,
    formActionComponents,
    classes,
}: EstablishementAdressFormWrapperProps) {
    const {
        handleSubmit,
        formState: { errors },
        control,
        watch,
    } = useForm({
        defaultValues,
        resolver: yupResolver(validationSchema),
    });

    const _onSubmit = (data: any) => {
        onSubmit(data);
    };

    const useDiffrentBillingAddress = watch("useDiffrentBillingAddress");

    return (
        <form
            onSubmit={handleSubmit(_onSubmit)}
            className={className ?? "signup-form"}
        >
            <AddressForm
                control={control}
                addressType="contactAddress"
                errors={errors}
                classes={classes}
            />

            <Controller
                name={"useDiffrentBillingAddress"}
                control={control}
                render={({ field: { ref, ...others } }) => (
                    <CustomCheckBox
                        label="Adresse de facturation différente"
                        {...others}
                        checked={useDiffrentBillingAddress}
                    />
                )}
            />

            {useDiffrentBillingAddress ? (
                <AddressForm
                    control={control}
                    addressType="billingAddress"
                    errors={errors}
                    classes={classes}
                />
            ) : null}
            {formActionComponents.submit}
            {formActionComponents.cancel}
        </form>
    );
}
